import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgIncipient = (props: ToothSvgComponentProps) => (
  <svg
    width={17 * (props.wx ?? 1)}
    height={27 * (props.hx ?? 1)}
    viewBox="0 0 17 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M8.47905 1.80476C7.14628 1.80476 3.68004 -0.118494 1.67779 1.98137C0.0735238 3.66421 0.665972 7.71066 1.81568 10.4346C2.24361 11.4477 2.22507 12.704 2.13948 13.8779C1.79571 18.5799 3.32961 25.8182 4.7318 25.7335C6.16965 25.6464 6.04079 17.0265 8.21136 16.2744C9.47946 15.835 9.77521 18.0952 10.0567 20.2118C10.3933 22.7439 10.1951 25.3884 10.9107 25.6597C11.7437 25.9753 13.3242 23.855 14.1639 20.0037C14.6151 17.9343 14.8096 15.5964 14.7525 13.9069C14.7154 12.8135 14.714 11.4481 15.142 10.4351C16.2921 7.71161 16.8846 3.66469 15.2798 1.98185C13.2776 -0.118018 9.81135 1.80523 8.47858 1.80523L8.47905 1.80476Z"
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.4263 3.13446C16.4016 5 15.4964 7.63446 15.4964 7.63446C14.4964 7.13446 12.0465 5.63442 12.0464 5.13447C12.0463 4.63451 15.0758 2.46398 15.4263 3.13446Z"
      fill={props.findingsFill || '#FF5140'}
    />
    <path
      d="M1.54653 3.13451C0.746533 4.98108 1.45655 7.63451 1.45655 7.63451C2.45655 7.13451 4.93643 5.63447 4.93652 5.13451C4.93661 4.63456 1.8473 2.44028 1.54653 3.13451Z"
      fill={props.findingsFill || '#FF5140'}
    />
  </svg>
);
export default SvgIncipient;
